import React, { useCallback, useState, useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { InputAdornment, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import {
  tA11y,
  translate,
} from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { FONT_GSS_FUTURA } from '@monorepo/shared/src/themes/defaultTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import useResources from '@monorepo/shared/src/hooks/use-resources';

const getTranslation = (key) => translate('resources', key);

const ResourcesSearchFilter: React.FC = () => {
  const [searchText, setSearchText] = useState('');
  const [{ resourcesSearchText }, { setResourcesSearchText }] = useResources();
  const classes = useStyles();

  useEffect(() => {
    /*
        We only care about listening to 'resourcesSearchText' state
        changes when the filters are cleared
    */
    if (!resourcesSearchText) {
      setSearchText(resourcesSearchText);
    }
  }, [resourcesSearchText]);

  const handleSearchTextChange = useCallback((event): void => {
    setSearchText(event.target.value);
    setResourcesSearchText(event.target.value);
  }, []);

  return (
    <div className={classes.search}>
      <label className={classes.searchlabel} htmlFor="searchbox">
        {getTranslation('searchLabel')}
      </label>
      <TextField
        id="searchbox"
        className={classes.searchInput}
        role="search"
        aria-label={tA11y('aria.search')}
        onChange={handleSearchTextChange}
        value={searchText}
        placeholder={getTranslation('searchPlaceholder')}
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
              <FontAwesomeIcon icon={faSearch} color="black" />
            </InputAdornment>
          ),
          classes: { input: classes.inputText },
        }}
      />
    </div>
  );
};

const useStyles = makeStyles({
  inputText: {
    fontSize: '1rem',
    '&::placeholder': {
      color: '#757575',
      opacity: 1,
    },
    padding: '8px 0',
    height: '100%',
    '&:focus-within': {
      boxShadow: 'none !important',
    },
  },
  search: {
    color: '#202020',
    fontFamily: FONT_GSS_FUTURA,
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '18px',
    paddingTop: '10px',
    paddingBottom: '15px',
  },
  searchInput: {
    backgroundColor: '#FFFFFF',
    border: '2px solid #000000',
    borderRadius: '8px',
    color: '#202020',
    display: 'block',
    fontFamily: FONT_GSS_FUTURA,
    height: remCalc(44),
    marginRight: 10,
    '&:focus-within': {
      outline: '#248AFF auto 1px',
    },
    paddingLeft: 5,
    paddingRight: 5,
    width: remCalc(215),
    '& fieldset': {
      border: 'none', // Removes the border
    },
  },
  searchlabel: {
    display: 'block',
    fontWeight: 400,
    marginBottom: '2px',
    paddingLeft: '3px',
  },
});

export default ResourcesSearchFilter;
